// lib
import React from "react";
import PropTypes from "prop-types";
// src
import DatePicker from "containers/plannings/partials/datePicker/DatePicker";
import PresetPicker from "containers/plannings/partials/presetPicker/PresetPicker";

const Aside = ({ maxHeight }) => (
  <aside className="aside-menu" style={{ height: maxHeight }}>
    <DatePicker />
    <PresetPicker />
  </aside>
);

Aside.propTypes = {
  // from parent
  maxHeight: PropTypes.any,
};

Aside.defaultProps = {
  maxHeight: "auto",
};

export default Aside;
